import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectNews, loadNews, } from "../news/newsSlice";
import style from "./style.module.css";

const News = () => {
  const newsState = useSelector(selectNews);
  console.log(`newsState: ${newsState}`);
  const newsData = newsState.news;
  console.log(`newsData: ${newsData}`);
  const dispatch = useDispatch();

  //set different background color for different article and cycle/rotate
  // "#ececcd","#e5e5bb"
  const COLOR_ARRAY = [ "#fafaf2", "#edf7f8", "#ffffff", "#f3f3e0","#edf7f8"];

  // rotate function
  // const arr = ["A", "B", "C", "D"];
  // let index = 0;

  // function nextElement() {
  //   index = (index + 1) % arr.length;
  //   return arr[index];
  // }

  //load and render the news during the first time page load
  useEffect(() => {
    console.log("inside News useEffect..");
    dispatch(loadNews());
  }, [dispatch]);

  return (
    <>
      {/* Page-Banner section starts...*/}
      <section>
        <div className="pageBanner">
          <div className="bannerContent">
            <h1 className="page-banner-title">News</h1>
          </div>
        </div>
      </section>
      {/* Page-Banner section ends...*/}

      <section className={`container-fluid d-flex flex-column justify-content-center ${style.newsSection}`}>
        {newsData.map((newsItem, index) => {
          console.log(newsData);
          return (
            <article
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ backgroundColor: COLOR_ARRAY[0] }}
            >
              <h2 key={`newsItem_title_${index}`} style={{textAlign:"justify",color:"darkblue",fontWeight:"bold"}}>{newsItem.title}</h2>
              <h5 key={`newsItem_location_${index}`} style={{color:"darkblue",fontWeight:"bold"}}>{newsItem.location}</h5>
              <p key={`newsItem_date_${index}`} style={{color:"darkblue",fontWeight:"bold"}}>{newsItem.date}</p>              
              <br/>
              {newsItem.description.map( paragraph => {  
                console.log(paragraph);               
                return (
                <p
                  key={`newsItem_description_${index}`}
                  className="px-lg-5 py-3" /*change for the responsive font size here*/
                  style={{ color:"darkblue", textAlign: "start" }}
                  >
                    {paragraph}
                </p>
              )})}
              <br/>
              <br/>

              {/* <div className="row d-flex g-1 justify-content-sm-center justify-content-md-around align-items-center"> */}
              <div className="row d-flex g-1 flex-column justify-content-center align-items-center py-1">
                {newsItem.img.map((pic, i) => {
                  return (
                    // <div className= { newsItem.img.length <= 1 ? "col-md-10" : "col-md-10 col-lg-6 " }>
                    <div className="col-12 mx-auto">
                      <figure
                        key={`newsItem_img_figure_${index}_${i}`}
                        className="figure"
                      >
                        {/* #b39700 */}
                        <img
                          key={`newsItem_img_img_${index}_${i}`}
                          src={pic}
                          className="figure-img img-fluid img-thumbnail mx-auto  d-block"
                          alt={`pic-${index}-${i}`}
                        />
                        {/* <figcaption
                      key={`newsItem_img_figcaption_${index}_${i}`}
                      className="figure-caption text-center fs-6 fw-semibold"
                    >
                      {pic.caption || ""} 
                    </figcaption> */}
                      </figure>
                    </div>
                  );
                })}
              </div>
              <p></p>

              {/* Moves first element to the end */}
              <div style={{ display: "none" }}>
                {COLOR_ARRAY.push(COLOR_ARRAY.shift())}
              </div>
            </article>
          );
        })}
      </section>
    </>
  );
};

export default News;
